import { render, staticRenderFns } from "./addOrgAdmin.vue?vue&type=template&id=9d6d8832&"
import script from "./addOrgAdmin.vue?vue&type=script&lang=ts&"
export * from "./addOrgAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports